module.exports = __webpack_public_path__ + "media/images/suppliers/gbilabs-f2556db2f8dacad53f728badb4cdf812.png";